import {
  CONSTANT,
  hasQuebecServiceAddress,
  hBBQualificationFields
} from '../../utils/constant';
import { getFieldValue } from '../utils';

const {
  KEYS: { CHANNELS }
} = CONSTANT;

const isChannelValidForPhoneRemoval = channelName =>
  [
    CHANNELS.SBS_TELESALES_TI,
    CHANNELS.SMB_TI_Sales_Base_Management,
    CHANNELS.SMB_TI_Sales_Digital
  ].includes(channelName);

const isChannelOptikTvCompatible = channelName =>
  [
    'SMB Growth Sales W 2A',
    'SMB Growth Sales W 2B',
    'SMB Growth Sales W 2C',
    'SMB Growth Sales W 2D',
    'SMB Growth Sales W 1A',
    'SMB Growth Sales W 1B',
    'SMB Growth Sales W 1C',
    'SMB Growth Sales W 1D',
    'SMB Growth Sales 30 to 100 2A',
    'SMB Growth Sales 30 to 100 2B',
    'SMB Growth Sales 30 to 100 2C',
    'SMB Retention Sales 30 to 100 2D',
    'SMB Growth Sales Advance WEST',
    'SMB New Growth Market 1',
    'SMB New Growth Market 2',
    'White Glove NBD Technicians',
    'SMB TI Sales Digital',
    'SMB TI Sales Base Management',
    'SMB TI ADT Retention',
    'SMB TI Digital - EN',
    'SMB TI Digital - FR',
    'SMB TI HSIA Growth',
    'SMB TI NBS Value Add',
    'SMB TI WLN Retention',
    'SMB TI WLS Growth QC',
    'SMB TI WLS Growth ROC',
    'SBS Telesales TI',
    'SMB L&R 2',
    'SMB L&R 3',
    'SMB L&R 4',
    'SMB L&R 5',
    'SMB L&R TI',
    'SMB L&R TI 2',
    'SMB L&R TI 3',
    'SMB RFS 1',
    'SMB RFS 2'
  ].includes(channelName);

const isChannelOptikTvCompatibleABAndBC = channelName =>
  ['DEALER'].includes(channelName);

const isChannelVulcanCompatible = channelName =>
  ['TM Test Ind Dlr', 'CORP_STORE'].includes(channelName);

const is7XChannel = channelName => channelName === CHANNELS['7X'];

const isNGM = channelName => channelName === CHANNELS.NGM;

const isSbsTelesalesTiChannel = channelName =>
  channelName === CHANNELS.SBS_TELESALES_TI;

const isChannelSMBDigitalFr = channelName =>
  channelName === CHANNELS['SMB TI Digital - FR'];

const isSMBGrowthSalesCBS = channelName =>
  channelName === CHANNELS['SMB Growth Sales CBS'];

const hasQuebecInAddress = (address = '') => {
  return hasQuebecServiceAddress.some(serviceAddress =>
    address.includes(serviceAddress)
  );
};

const getHBBQualificationAnswers = formFields => {
  const hBBQualificationValues = [];
  hBBQualificationFields.forEach(key => {
    hBBQualificationValues.push(getFieldValue(key, formFields));
  });
  return hBBQualificationValues;
};

export {
  isChannelValidForPhoneRemoval,
  isChannelOptikTvCompatible,
  isChannelOptikTvCompatibleABAndBC,
  isChannelVulcanCompatible,
  is7XChannel,
  isNGM,
  isSbsTelesalesTiChannel,
  isChannelSMBDigitalFr,
  isSMBGrowthSalesCBS,
  hasQuebecInAddress,
  getHBBQualificationAnswers
};
